import { useQuery } from "@tanstack/react-query";
import React from "react";
import toast from "react-hot-toast";

const AllUsers = () => {
  const { data: users = [], refetch } = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const res = await fetch(
        "https://doctors-portal-server-azure.vercel.app/users",
        {
          headers: {
            authorization: "Bearer " + localStorage.getItem("doctors_token"),
          },
        }
      );
      const data = await res.json();
      return data;
    },
  });

  const handleMakeAdmin = (id, name) => {
    fetch(`https://doctors-portal-server-azure.vercel.app/users/admin/${id}`, {
      method: "PUT",
      headers: {
        authorization: "bearer " + localStorage.getItem("doctors_token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount) {
          toast.success(name + " Now an admin");
          refetch();
        }
      });
  };

  return (
    <section className="bg-[#F1F5F9] px-14 py-7 min-h-screen">
      {/* All users header */}
      <div className="flex justify-between items-center py-7">
        <p className="text-lg font-medium">All users</p>
      </div>
      <div className="overflow-x-auto ">
        <table className="table w-full">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Email</th>
              <th>Password</th>
              <th>Admin</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => {
              return (
                <tr className="hover" key={user._id}>
                  <th>{++index}</th>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.password}</td>
                  <td>
                    {user?.role !== "admin" && (
                      <button
                        onClick={() => handleMakeAdmin(user._id, user.name)}
                        className="btn btn-xs btn-primary"
                      >
                        Make admin
                      </button>
                    )}
                  </td>
                  <td>
                    <button className="btn btn-xs bg-red-600">Delete</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default AllUsers;
